interface FadingWordProps {
  children: React.ReactNode;
  isVisible: boolean;
}

export const FadingWord = ({ isVisible, children }: FadingWordProps) => (
  <span className={isVisible ? "animate-fade-in-slow" : "hidden"}>
    {children}
  </span>
);
